import * as React from "react";

function SmallAddSvg(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 10h10"
        stroke="url(#paint0_linear_1450_2613)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15V5"
        stroke="url(#paint1_linear_1450_2613)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1450_2613"
          x1={10}
          y1={10}
          x2={10}
          y2={11}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1450_2613"
          x1={10.5}
          y1={5}
          x2={10.5}
          y2={15}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SmallAddSvg;
